// extracted by mini-css-extract-plugin
module.exports = {"code":"g_f"};